//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'SettingsThemeColor',
  props: {
    color: {
      type: String,
      default: '',
      required: true
    },
    colors: {
      type: Array,
      default: function _default() {
        return [];
      },
      required: true
    },
    customerColor: {
      type: String,
      default: function _default() {
        return '#44EB2C';
      },
      required: false
    }
  },
  data: function data() {
    return {
      currentColor: this.color,
      currentCustomerColor: this.customerColor
    };
  },
  watch: {
    color: function color() {
      this.currentColor = this.color;
    },
    customerColor: function customerColor() {
      this.currentCustomerColor = this.customerColor;
    }
  },
  methods: {
    setColor: function setColor(color) {
      this.currentColor = color;
      this.$emit('input', color);
    },
    setCustomColor: function setCustomColor(colorObj) {
      this.$emit('input:customer', colorObj.hex);
    }
  }
};